const colors = {
  primary: '#0091EA',
  primaryDark: '#01579B',
  secondaryGreen: '#00BFA5',
  infoMain: '#00ACC1',
  textPrimary: 'rgba(0, 0, 0, 0.5)',
  textPrimaryHover: 'rgba(0, 0, 0, 0.7)',
  textSecondary: 'rgba(97, 97, 97, 0.9)',
  textDisabled: 'rgba(170, 170, 170, 0.8)',
  btnPrimary: '#282750',
  btnOrange: 'linear-gradient(180deg, #FA9A51 0%, #DB3E56 100%)',
  textOrange: '#FA9152',
  grey100: '#F5F5F5',
};

export default colors;
